/* 🤖 this file was generated by svg-to-ts */
export const mgcIconPadFilled: {
  name: 'pad-filled';
  data: string;
} = {
  name: 'pad-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M5.58 2.047c-.733.14-1.4.821-1.537 1.57-.061.334-.061 16.432 0 16.766.141.768.806 1.433 1.574 1.574.333.06 12.433.06 12.766 0 .768-.141 1.433-.806 1.574-1.574.061-.334.061-16.432 0-16.766-.141-.768-.806-1.433-1.574-1.574-.306-.056-12.508-.052-12.803.004m6.881 14.064c.712.366.715 1.411.004 1.776a1.02 1.02 0 0 1-1.334-.398c-.095-.161-.111-.233-.111-.489s.016-.328.111-.489c.124-.211.315-.373.539-.456.201-.075.59-.048.791.056"/></svg>`
};
